import React from 'react';

interface OwnProps {
  /** Tooltip text. Also used as the accessible label if `aria-label` is not provided. */
  title: string;
  ariaLabel?: string;
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Icon button used in the header (back, copy workflow id...).
 *
 * The visual styling is scoped by the parent (`.app-navbar button.icon-btn`)
 * in `styles.css` because this button needs to inherit the gradient navbar
 * context. The component itself is a thin accessibility wrapper.
 */
const IconButton = ({ title, ariaLabel, children, onClick }: OwnProps) => (
  <button
    type='button'
    onClick={onClick}
    className='icon-btn'
    title={title}
    aria-label={ariaLabel ?? title}
  >
    {children}
  </button>
);

const MemoIconButton = React.memo(IconButton);

export { MemoIconButton as IconButton };
export default MemoIconButton;
